import { useEffect } from 'react'
import { usePopUpMembershipStore } from '../stores/pop-up-membership-store'
import { useAccount } from '../../../hooks/useAccount'

export function useMembershipNotification() {
  const { isLogin, account } = useAccount()

  const { popupShown, status, setStatus, markPopupShown, resetPopup } =
    usePopUpMembershipStore(state => ({
      popupShown: state.popupShown,
      status: state.status,
      setStatus: state.setStatus,
      markPopupShown: state.markPopupShown,
      resetPopup: state.resetPopup,
    }))

  // Reset ketika logout
  useEffect(() => {
    if (!isLogin) {
      resetPopup()
    }
  }, [isLogin, resetPopup])

  // Hitung status hanya ketika login
  useEffect(() => {
    if (!isLogin) return
    if (!account || !account.dateExpired) return
    if (popupShown) return

    const now = new Date()
    const expire = new Date(account.dateExpired)

    const diffDays = Math.ceil(
      (expire.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)
    )

    if (diffDays <= 0) {
      setStatus('expired')
    } else if (diffDays <= 7) {
      setStatus('warning')
    }
  }, [isLogin, account, popupShown, setStatus])

  const shouldShow = !popupShown && Boolean(status)

  const onClose = () => {
    markPopupShown()
  }

  // Lock tombol back saat popup muncul
  useEffect(() => {
    if (!shouldShow) return

    const blockBack = () => {
      window.history.pushState(null, document.title, window.location.href)
    }

    window.history.pushState(null, document.title, window.location.href)
    window.addEventListener('popstate', blockBack)

    return () => {
      window.removeEventListener('popstate', blockBack)
    }
  }, [shouldShow])

  return { account, shouldShow, status, onClose }
}
